import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../css/brochure.css";
import sprite from "../assets/brochure/sprite.svg";
import Navbar from "../components/navbar";

import img1 from "../assets/brochure/1.png";
import img2 from "../assets/brochure/2.png";
import img3 from "../assets/brochure/3.png";
import img4 from "../assets/brochure/4.png";
import img5 from "../assets/brochure/5.png";
import img6 from "../assets/brochure/6.png";
import img7 from "../assets/brochure/7.png";
import img8 from "../assets/brochure/8.png";
import img9 from "../assets/brochure/9.png";
import img10 from "../assets/brochure/10.png";
import img11 from "../assets/brochure/11.png";
import img12 from "../assets/brochure/12.png";
import img13 from "../assets/brochure/13.png";
import img14 from "../assets/brochure/14.png";
import img15 from "../assets/brochure/15.png";
import img16 from "../assets/brochure/16.png";
import img17 from "../assets/brochure/17.png";
import img18 from "../assets/brochure/18.png";
import img19 from "../assets/brochure/19.png";
import img20 from "../assets/brochure/20.png";
import img21 from "../assets/brochure/21.png";
import img22 from "../assets/brochure/22.png";
import img23 from "../assets/brochure/23.png";
import img24 from "../assets/brochure/24.png";
import img25 from "../assets/brochure/25.png";
import img26 from "../assets/brochure/26.png";
import img27 from "../assets/brochure/27.png";
import img28 from "../assets/brochure/28.png";
import img29 from "../assets/brochure/29.png";
import img30 from "../assets/brochure/30.png";
import img31 from "../assets/brochure/31.png";
import img32 from "../assets/brochure/32.png";
import img33 from "../assets/brochure/33.png";
import img34 from "../assets/brochure/34.png";
import img35 from "../assets/brochure/35.png";
import img36 from "../assets/brochure/36.png";
import img37 from "../assets/brochure/37.png";
import img38 from "../assets/brochure/38.png";
import img39 from "../assets/brochure/39.png";
import img40 from "../assets/brochure/40.png";
import img41 from "../assets/brochure/41.png";
import img42 from "../assets/brochure/42.png";
import img43 from "../assets/brochure/43.png";
import img44 from "../assets/brochure/44.png";
import img45 from "../assets/brochure/45.png";
import img46 from "../assets/brochure/46.png";
import img47 from "../assets/brochure/47.png";
import img48 from "../assets/brochure/48.png";

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
];

function Brochure() {
  const rotateAnimationHandler = (props, state) => {
    const transitionTime = props.transitionTime + "ms";
    const transitionTimingFunction = "ease-in-out";
    let slideStyle = {
      display: "block",
      minHeight: "100%",
      transitionTimingFunction: transitionTimingFunction,
      msTransitionTimingFunction: transitionTimingFunction,
      MozTransitionTimingFunction: transitionTimingFunction,
      WebkitTransitionTimingFunction: transitionTimingFunction,
      OTransitionTimingFunction: transitionTimingFunction,
      transform: `rotate(0)`,
      position:
        state.previousItem === state.selectedItem ? "relative" : "absolute",
      inset: "0 0 0 0",
      zIndex: state.previousItem === state.selectedItem ? "1" : "-2",
      opacity: state.previousItem === state.selectedItem ? "1" : "0",
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime,
    };
    return {
      slideStyle,
      selectedStyle: {
        ...slideStyle,
        opacity: 1,
        position: "relative",
        zIndex: 2,
        filter: `blur(0)`,
      },
      prevStyle: {
        ...slideStyle,
        transformOrigin: " 0 100%",
        transform: `rotate(${
          state.previousItem > state.selectedItem ? "-45deg" : "45deg"
        })`,
        opacity: "0",
        filter: `blur( ${
          state.previousItem === state.selectedItem ? "0px" : "5px"
        })`,
      },
    };
  };
  return (
    <>
      <Navbar />
      <div className="brochure-page">
        <div className="brochure-box">
          <Carousel
            showIndicators
            renderArrowNext={(clickHandler, hasNext) => {
              return (
                hasNext && (
                  <button
                    className="nav_btn nav_btn_right"
                    onClick={clickHandler}
                  >
                    <svg>
                      <use xlinkHref={sprite + "#right"}></use>
                    </svg>
                  </button>
                )
              );
            }}
            renderArrowPrev={(clickHandler, hasNext) => {
              return (
                hasNext && (
                  <button
                    onClick={clickHandler}
                    className="nav_btn nav_btn_left"
                  >
                    <svg>
                      <use xlinkHref={sprite + "#left"}></use>
                    </svg>
                  </button>
                )
              );
            }}
            // renderIndicator={(clickHandler, isSelected, index) => {
            //   return (
            //     <li
            //       onClick={clickHandler}
            //       className={`ind ${isSelected ? "active" : ""}`}
            //       key={index}
            //       role="button"
            //     />
            //   );
            // }}
            statusFormatter={(currentItem, total) => {
              return (
                <p className="para-head">
                  Page {currentItem} of {total}
                </p>
              );
            }}
            transitionTime={310}
            animationHandler={rotateAnimationHandler}
            swipeable={false}
          >
            {images.map((URL, index) => (
              <div className="slide">
                <img alt="sample_file" src={URL} key={index} />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
}
export default Brochure;
